import React from "react";

import { StatusBadgeProps } from "./statusBadgeProps";

export const ConfirmedStatusBadge = (props: StatusBadgeProps) => {
    const { width, height = "18", viewBox = "0 0 76.8 18", ...rest } = props;

    return (
        <svg
            width={width}
            height={height}
            viewBox={viewBox}
            {...rest}
            enableBackground="enable-background:new 0 0 141.8 18;"
            xmlSpace="preserve"
        >
            <g>
                <g transform="translate(-957 -10126)">
                    <g transform="translate(957 10126)">
                        <path
                            fill="#7E66D8"
                            fillRule="evenodd"
                            d="M1.9 0h72.9c1.1 0 1.9.9 1.9 2v14c0 1.1-.9 2-1.9 2H1.9c-1 0-1.9-.9-1.9-2V2C0 .9.9 0 1.9 0z"
                        ></path>
                    </g>
                </g>
            </g>
            <path
                fill="#FFF"
                d="M6.3 8.7c0-2.5 1.4-4 3.7-4 1.6 0 2.8.8 3.3 2.2l-1.1.4c-.4-1-1.1-1.5-2.2-1.5-1.6 0-2.5 1-2.5 2.8 0 1.8.9 2.9 2.5 2.9 1.1 0 1.9-.5 2.3-1.5l1.1.4c-.6 1.5-1.8 2.2-3.4 2.2-2.3.1-3.7-1.4-3.7-3.9zM14.1 8.8c0-2.4 1.5-4 3.6-4s3.6 1.6 3.6 4-1.5 4-3.6 4c-2.2-.1-3.6-1.7-3.6-4zm6 0c0-1.8-.9-2.9-2.4-2.9S15.3 7 15.3 8.8c0 1.8 1 2.8 2.4 2.8s2.4-1.1 2.4-2.8zM28.7 4.9v7.7h-1.2L24.1 7v5.6h-1.2V4.9h1.2l3.4 5.6V4.9h1.2zM30.9 4.9h5.4V6H32v2.1h3.7v1.1H32v3.4h-1.2V4.9zM37.6 4.9h1.2v7.7h-1.2V4.9zM45.1 12.6l-1.9-3.3H42v3.3h-1.2V4.9h2.4c1.8 0 2.6.8 2.6 2.2 0 1.1-.5 1.8-1.5 2.1l2.1 3.4h-1.3zm-1.9-4.4c1 0 1.5-.3 1.5-1.1S44.2 6 43.2 6h-1.1v2.2h1.1zM55.5 4.9v7.7h-1.2v-6L52.2 12H51l-2-5.5v6h-1.2V4.9h1.7l2.1 5.7 2.2-5.7h1.7zM57.6 4.9h5.1V6h-3.9v2.1h3.6v1.1h-3.6v2.3h3.9v1.1h-5.1V4.9zM64.4 4.9h2.2c2.5 0 4 1.4 4 3.9 0 2.4-1.4 3.8-4 3.8h-2.2V4.9zm2 6.6c2 0 2.9-.8 2.9-2.7 0-1.9-.9-2.8-2.8-2.8h-1v5.5h.9z"
            ></path>
        </svg>
    );
};
